module.exports = __webpack_public_path__ + "img/eg6.89926cd5.png";